import { StyleSheet } from 'react-native';
import { IS_WEB } from '@/utils/platform';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  setPasswordContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    backgroundColor: colors.black,
  },
  setPasswordBtnContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  btn: {
    flex: 1,
    borderRadius: 4,
    marginHorizontal: 10,
  },
  setPasswordText: {
    textAlign: 'center',
    fontWeight: '700',
    paddingVertical: 10,
    fontSize: 16,
    color: colors.white,
  },

  container: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    backgroundColor: colors.black,
    paddingTop: IS_WEB ? '12%' : 0,
  },
  btnContainer: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: colors.black,
    paddingBottom: 10,
  },
  flexOne: {
    flex: 1,
  },
  text: {
    textAlign: 'center',
    fontWeight: '700',
    paddingVertical: 10,
    fontSize: 16,
    color: colors.white,
  },
  selfTrainingButton: {
    backgroundColor: 'white',
    borderRadius: 8,
    alignSelf: 'center',
    padding: 20,
    flexDirection: 'row',
    alignContent: 'center',
  },
  selfTrainingButtonText: {
    color: 'black',
    fontSize: 28,
    paddingLeft: 10,
  },
});
